<template>
  <topbar
    :titulo="$t('FINANCEIRO.GERENCIAR_BOLETOS')"
    :subtitulo="$t('FINANCEIRO.GERENCIAR_BOLETOS_DESCRICAO')"
    :breadcrumbs="breadcrumbs"
  />
</template>

<script>
// Utils & Aux:
import Topbar from '@/layouts/full-layout/horizontal-sidebar/Topbar.vue';

export default {
  components: { Topbar },
  data() {
    return {
      breadcrumbs: [
        { titulo: this.$t('FINANCEIRO.FINANCEIRO') },
        { titulo: this.$t('FINANCEIRO.GERENCIAR_BOLETOS') },
      ],
    };
  },
};
</script>
